export default __webpack_public_path__ + "static/media/air_rune.73dfed38.svg";